import { onBeforeUnmount, unref } from "vue";
import { useEmitter } from "./useEmitter";

const SHOW_EDIT_SAVED = "show-edit-saved";
const resolve = value => unref(typeof value === "function" ? value() : value);
const hasId = id => id !== undefined && id !== null && id !== "";

const normalizePath = (path, rowId) => {
  const normalized = String(path ?? "")
    .split(/[?#]/)[0]
    .replace(/^\/+|\/+$/g, "");
  const suffix = `/${rowId}`;

  return normalized.endsWith(suffix) ? normalized.slice(0, -suffix.length) : normalized;
};

/** Вызывать только после успешного сохранения edit-формы. */
export const notifyShowEdit = data => useEmitter().emit(SHOW_EDIT_SAVED, data);

/**
 * path, rowId и необязательный grid принимают значения, ref или getter.
 * reload заново загружает всю карточку; подписка снимается при уничтожении компонента.
 */
export const useShowEdit = ({ path, rowId, grid, reload }) => {
  const emitter = useEmitter();

  const onEditSaved = (data = {}) => {
    const currentId = resolve(rowId);

    if (!hasId(currentId) || !hasId(data.rowId) || String(currentId) !== String(data.rowId)) return;

    const currentPath = normalizePath(resolve(path), currentId);
    const savedPath = normalizePath(data.path, data.rowId);
    const currentGrid = resolve(grid);
    const samePath = currentPath && currentPath === savedPath;
    // У некоторых карточек заявок show и edit используют разные API-пути одного грида.
    const sameGrid = currentGrid && currentGrid === data.grid;

    if (samePath || sameGrid) return reload();
  };

  emitter.on(SHOW_EDIT_SAVED, onEditSaved);

  const stop = () => emitter.off(SHOW_EDIT_SAVED, onEditSaved);
  onBeforeUnmount(stop);

  return stop;
};
